<template>
	<ui-modal @toggle="$emit('toggle')">
		<div class="flex flex-col gap-2" v-if="!loading">
			<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700">
				<template v-slot:text>
					<p>Filtres</p>
				</template>
			</ui-title>
			<form-validation-errors class="lg:col-span-2"></form-validation-errors>
			<form @submit.prevent="doSearch" @keydown.enter.prevent="doSearch" class="flex flex-col lg:grid lg:grid-cols-2 gap-2">
				<!-- NAME -->
				<form-input class="lg:col-span-2" placeholder="Nom" v-model="form.name"> </form-input>
				<!-- TYPE -->
				<form-select
					:items="page.props.str.statuses.filter((status) => status.type == 'structure')"
					placeholder="Type"
					@valueChange="form.type = $event"
					:value="form.type"
					class="col-span-2">
				</form-select>
				<!-- ADRESSE -->
				<form-input placeholder="Code postal, ville" v-model="form.address"> </form-input>
				<!-- PRO ID -->
				<form-input placeholder="Identifiant professionnel (FINESS)" v-model="form.pro_id"> </form-input>
				<!-- SKILLS -->
				<h3 class="text-lg border-b-2 mt-2 col-span-2">Profession(s)</h3>
				<!-- DROPDOWN ADD SKILL -->
				<ui-dropdown ref="dropdownTest" class="col-span-2">
					<template #content>
						<form-input placeholder="Recherche" v-model="searchSkills" class="w-full border-none"> </form-input>
						<div
							v-for="skill in searchSkill"
							:key="skill.id"
							class="p-3 text-center hover:bg-slate-500 hover:text-white cursor-pointer"
							@click="skillAdd(skill)"
							data-trigger="close">
							{{ skill.name }}
						</div>
					</template>
					<template v-slot:trigger>
						<ui-button class="w-full">
							<template v-slot:icon>
								<i class="fas fa-plus-circle"></i>
							</template>
							<template v-slot:text>Ajouter</template>
						</ui-button>
					</template>
				</ui-dropdown>
				<!-- SKILL LIST -->
				<div class="flex flex-col gap-3 justify-between col-span-2">
					<div class="flex flex-wrap gap-1" v-if="form.skills.length > 0">
						<div
							v-for="skill in form.skills"
							:key="skill"
							class="text-slate-700 bg-slate-50 border border-blue-500 rounded-md p-2 px-5 whitespace-nowrap relative overflow-hidden cursor-pointer hover:border-red-400 group"
							@click.prevent="skillDelete(skill)">
							{{ page.props.str.statuses.find((element) => element.id == skill)?.name }}
							<div
								class="absolute top-0 left-0 bg-red-500 w-full h-full hidden group-hover:flex items-center justify-center text-white">
								<i class="fas fa-trash"></i>
							</div>
						</div>
					</div>
				</div>
				<ui-button type="button" class="col-span-2 mt-3 font-bold border-2" position="center" @click="doSearch">
					<template v-slot:text>Rechercher</template>
				</ui-button>
			</form>
		</div>
		<div v-else class="h-full w-full flex items-center justify-center text-2xl">
			<i class="fas fa-circle-notch fa-spin"></i>
		</div>
	</ui-modal>
</template>

<script setup>
	import { ref, computed, onMounted } from 'vue';
	import { usePage, router } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';

	const page = usePage();

	const props = defineProps({
		searchForm: {
			type: Object,
			default: () => ({}),
		},
	});

	const emit = defineEmits(['toggle']);

	const loading = ref(false);
	const searchSkills = ref('');

	const form = ref({
		name: null,
		address: null,
		type: null,
		pro_id: null,
		skills: [],
	});

	const searchSkill = computed(() => {
		if (searchSkills.value) {
			return page.props.str.statuses
				.filter((w) => w.type === 'skill')
				.filter((w) => w.name.toLowerCase().includes(searchSkills.value.toLowerCase()));
		}
		return page.props.str.statuses.filter((w) => w.type === 'skill');
	});

	const doSearch = () => {
		loading.value = true;
		router.get(route('structures.index'), {
			params: form.value,
		});
	};

	const skillAdd = (skill) => {
		if (form.value.skills.includes(skill.id)) {
			toast.error('La profession est déjà présente dans la liste');
		} else {
			form.value.skills.push(skill.id);
		}
	};

	const skillDelete = (skill) => {
		form.value.skills = form.value.skills.filter((element) => element !== skill);
	};

	onMounted(() => {
		if (Object.keys(props.searchForm).length > 0) {
			form.value.name = props.searchForm.name || null;
			form.value.address = props.searchForm.address || null;
			form.value.type = props.searchForm.type || null;
			form.value.pro_id = props.searchForm.pro_id || null;
			form.value.skills = props.searchForm.skills || [];
		}
	});
</script>
